import { GridColDef } from "@mui/x-data-grid";
import { CustomDataGrid } from "../../../components/common/CustomDataGrid";
import { useTheme } from "../../../components/hooks/useTheme";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Divider, Menu, MenuItem, Stack } from "@mui/material";
import baseURL from "../../../configs/api";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";


type VehiclesListProps = {
    activeIndex: number;
    activeTabLable: string;
    paginationModel: any;
    setPaginationModel: (value: any) => void;
    searchValue: string;
    setSearchValue: (value: string) => void;
    vehicleFilterValue: number;
    setVehicleFilterValue: (value: number) => void;
    selectedFilter: string;
    setSelectedFilter: (value: string) => void;
    filterItems: any[]
}

export const VehiclesList = ({
    activeIndex,
    activeTabLable,
    paginationModel,
    setPaginationModel,
    searchValue,
    setSearchValue,
    vehicleFilterValue,
    setVehicleFilterValue,
    selectedFilter,
    setSelectedFilter,
    filterItems
}: VehiclesListProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { handleTenantError }: any = useTenant();
    const [loading, setLoading] = useState(true);
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [columnFilterAnchorEl, setColumnFilterAnchorEl] = useState<null | HTMLElement>(null);
    const columnFilterOpen = Boolean(columnFilterAnchorEl);
    const initialColumns: GridColDef[] = [
        {
            field: "vehicleKey",
            headerName: "Vehicle Key",
            width: 300,
            editable: false,
            sortable: false,
            align: "left",
            renderCell: (params) => {
                return (
                    <Link to="/fleet/vehicle/editvehicles" state={params?.id}
                        style={{
                            color: "var(--app-link-color)",
                            textDecoration: "underline",
                        }}
                    >
                        {params?.value}
                    </Link>
                );
            },
        },
        {
            field: "vin",
            headerName: "Vin",
            width: 300,
            align: "left",
            editable: false,
            sortable: false,
        },
        {
            field: "name",
            headerName: "Name",
            width: 200,
            align: "left",
            editable: false,
            sortable: false,
        },
        {
            field: "licensePlate",
            headerName: "License Plate",
            width: 300,
            align: "left",
            editable: false,
            sortable: false,
        },
        {
            field: "vehicleBarcode",
            headerName: "Vehicle Barcode",
            width: 300,
            align: "left",
            editable: false,
            sortable: false,
        },
        {
            field: "statusName",
            headerName: "Status",
            align: "left",
            width: 150,
            editable: false,
            sortable: true,
        },
        {
            field: "vehicleTypeName",
            headerName: "Vehicle Type",
            align: "left",
            editable: false,
            sortable: true,
            width: 300,
        },
        {
            field: "availableDate",
            headerName: "Available Date",
            align: "left",
            width: 300,
            editable: false,
            sortable: false,
        },
        {
            field: "vehicleMarkeName",
            headerName: "Make",
            align: "left",
            width: 300,
            editable: false,
            sortable: false,
        },
        {
            field: "vehicleModelName",
            headerName: "Vehicle Model",
            align: "left",
            width: 300,
            editable: false,
            sortable: false,
        },
        {
            field: "vehicleClassName",
            headerName: "Vehicle Class",
            align: "left",
            width: 300,
            editable: false,
            sortable: true,
        },
        {
            field: "vehiclSecondaryClassName",
            headerName: "Secondary Vehicle Classes",
            align: "left",
            width: 300,
            editable: false,
            sortable: false,
        },
        {
            field: "currentLocationName",
            headerName: "Current Location",
            width: 300,
            align: "left",
            editable: false,
            sortable: false,
        },
        {
            field: "odometer",
            headerName: "Odometer",
            width: 150,
            align: "left",
            editable: false,
            sortable: false,
        },
        {
            field: "fuelLevel",
            headerName: "Fuel Level",
            width: 80,
            align: "left",
            editable: false,
            sortable: false,
        },
    ];
    const [columns, setColumns] = useState<GridColDef[]>(initialColumns);
    const [selectedColumns, setSelectedColumns] = useState(initialColumns?.map(col => col?.headerName));

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleColumnFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setColumnFilterAnchorEl(event.currentTarget);
    };
    const handleColumnFilterClose = () => {
        setColumnFilterAnchorEl(null);
    };

    const toggleColumn = (headerName: string) => {
        setSelectedColumns(prev =>
            prev.includes(headerName) ? prev.filter(col => col !== headerName) : [...prev, headerName]
        );
    };

    useEffect(() => {
        const filterCol = initialColumns?.filter(col => selectedColumns?.includes(col?.headerName));
        setColumns(filterCol);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedColumns])

    const toggleAll = () => {
        if (selectedColumns?.length === initialColumns?.length) {
            setSelectedColumns([]);
        } else {
            setSelectedColumns(initialColumns?.map(col => col?.headerName));
        }
    };

    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                pageSize: paginationModel.pageSize,
            };

            setPaginationModel(newPaginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue === "") {
            setIsFirstTime(false);
            emptySearchApiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const emptySearchApiCall = (newPaginationModel: any) => {
        if (activeIndex === 0) {
            setLoading(true);
            fetch(`${baseURL}vehicles/GetVehicleReportPaging/${newPaginationModel.page},${newPaginationModel.pageSize}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const result = data.vehicleReports.map((item: any) => {
                        return {
                            ...item,
                            availableDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.availableDate)
                            ),
                            availableUntil: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.availableUntil)
                            ),
                            lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.lastMaintenanceDate)
                            ),
                            lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.lastWheelRotationDate)
                            ),
                            lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.lastWheelAlignmentDate)
                            ),
                        };
                    });


                    setSearchTableData(result);
                    setTotalLength(data.count);
                    setLoading(false);
                    handleTenantError(null);

                })
                .catch((error) => {
                    handleTenantError(error);
                    setSearchTableData([]);
                    setLoading(false);
                });
        }
        else if (activeTabLable === 'Available' || activeTabLable === 'Dirty') {
            setLoading(true);
            fetch(`${baseURL}vehicles/GetVehicleReportPagingWithStatusId/${activeIndex},${newPaginationModel.page},${newPaginationModel.pageSize}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const result = data.vehicleReports.map((item: any) => {
                        return {
                            ...item,
                            availableDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.availableDate)
                            ),
                            availableUntil: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.availableUntil)
                            ),
                            lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.lastMaintenanceDate)
                            ),
                            lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.lastWheelRotationDate)
                            ),
                            lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.lastWheelAlignmentDate)
                            ),
                        };
                    });


                    setSearchTableData(result);
                    setTotalLength(data.count);
                    setLoading(false);
                    handleTenantError(null);

                })
                .catch((error) => {
                    handleTenantError(error);
                    setSearchTableData([]);
                    setLoading(false);
                });
        }
        else {
            setLoading(true);
            fetch(`${baseURL}vehicles/GetVehicleReportPagingWithBranchId/${activeIndex},${newPaginationModel.page},${newPaginationModel.pageSize}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const result = data.vehicleReports.map((item: any) => {
                        return {
                            ...item,
                            availableDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.availableDate)
                            ),
                            availableUntil: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.availableUntil)
                            ),
                            lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.lastMaintenanceDate)
                            ),
                            lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.lastWheelRotationDate)
                            ),
                            lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                new Date(item.lastWheelAlignmentDate)
                            ),
                        };
                    });


                    setSearchTableData(result);
                    setTotalLength(data.count);
                    setLoading(false);
                    handleTenantError(null);

                })
                .catch((error) => {
                    handleTenantError(error);
                    setSearchTableData([]);
                    setLoading(false);
                });
        }
    }

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    pageSize: paginationModel?.pageSize,
                };

                setPaginationModel(newPaginationModel);
            }, 1000);
        }

        return () => clearTimeout(timeOutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue !== "") {
            apiCall(paginationModel);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const apiCall = (newPaginationModel: any) => {
        let filterData: any[] = [];
        setLoading(true);
        if (activeIndex === 0) {
            switch (vehicleFilterValue) {
                case 0:
                    fetch(`${baseURL}vehicles/GetVehicleReportSearchWithVehicleName?vehicleName=${searchValue}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 1:
                    fetch(`${baseURL}vehicles/GetVehicleReportSearchWithVehicleKey?vehicleKey=${searchValue}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 2:
                    fetch(`${baseURL}vehicles/GetVehicleReportSearchWithVin?vin=${searchValue}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 3:
                    fetch(`${baseURL}vehicles/GetVehicleReportSearchWithLicensePlate?licensePlate=${searchValue}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 4:
                    fetch(`${baseURL}vehicles/GetVehicleReportSearchWithBranchName?branchName=${searchValue}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;

            }
        }
        else if (activeTabLable === 'Available' || activeTabLable === 'Dirty') {
            switch (vehicleFilterValue) {
                case 0:
                    fetch(`${baseURL}vehicles/GetVehicleReportPagingSearchWithVehicleNameAndStatusId?vehicleName=${searchValue}&statusId=${activeIndex}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 1:
                    fetch(`${baseURL}vehicles/GetVehicleReportPagingSearchWithVehicleKeyAndStatusId?vehicleKey=${searchValue}&statusId=${activeIndex}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 2:
                    fetch(`${baseURL}vehicles/GetVehicleReportPagingSearchWithVinAndStatusId?vin=${searchValue}&statusId=${activeIndex}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 3:
                    fetch(`${baseURL}vehicles/GetVehicleReportPagingSearchWithLicensePlateAndStatusId?licensePlate=${searchValue}&statusId=${activeIndex}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);

                            handleTenantError(null);
                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 4:
                    fetch(`${baseURL}vehicles/GetVehicleReportPagingSearchWithBranchNameAndStatusId?branchName=${searchValue}&statusId=${activeIndex}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;

            }
        }
        else {
            switch (vehicleFilterValue) {
                case 0:
                    fetch(`${baseURL}vehicles/GetVehicleReportSearchWithVehicleNameAndBranchId?vehicleName=${searchValue}&branchId=${activeIndex}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 1:
                    fetch(`${baseURL}vehicles/GetVehicleReportSearchWithVehicleKeyAndBranchId?vehicleKey=${searchValue}&branchId=${activeIndex}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 2:
                    fetch(`${baseURL}vehicles/GetVehicleReportSearchWithVinAndBranchId?vin=${searchValue}&branchId=${activeIndex}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);
                            handleTenantError(null);

                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;
                case 3:
                    fetch(`${baseURL}vehicles/GetVehicleReportSearchWithLicensePlateAndBranchId?licensePlate=${searchValue}&branchId=${activeIndex}&page=${newPaginationModel.page}&size=${newPaginationModel.pageSize}`, {
                        headers: {
                            'X-Tenant-ID': tenantId,
                        }
                    })
                        .then((res) => res.json())
                        .then((data) => {

                            filterData = data.vehicleReports.map((item: any) => {
                                return {
                                    ...item,
                                    availableDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableDate)
                                    ),
                                    availableUntil: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.availableUntil)
                                    ),
                                    lastMaintenanceDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastMaintenanceDate)
                                    ),
                                    lastWheelRotationDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelRotationDate)
                                    ),
                                    lastWheelAlignmentDate: new Intl.DateTimeFormat("en-US").format(
                                        new Date(item.lastWheelAlignmentDate)
                                    ),
                                };
                            });



                            setSearchTableData(filterData);
                            setTotalLength(data.count);
                            setLoading(false);

                            handleTenantError(null);
                        })
                        .catch((error) => {
                            handleTenantError(error);
                            setSearchTableData([]);
                            setLoading(false);
                        });
                    break;

            }
        }
    }

    return (
        <div className="w-full mt-2">
            <div className={`w-full border ${themeStyles.main.borderColor} rounded-[16px]`}>
                <div className={`flex justify-between items-center p-4 border-b ${themeStyles.main.borderColor}`}>
                    <div className="flex items-center gap-1.5">

                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Vehicles</h2>

                        <div >
                            <button
                                className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid ${themeStyles.topBar.tailwindBorderColor}`}
                                aria-controls={columnFilterOpen ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={columnFilterOpen ? 'true' : undefined}
                                onClick={handleColumnFilterClick}
                            >
                                <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                >
                                    <span className={`${themeStyles.topBar.tailwindTextColor} text-[14px] font-medium`}>Columns</span>
                                    <span className={`material-symbols-outlined text-[18px] font-light ${themeStyles.main.textHeadingColor}`}>
                                        filter_alt
                                    </span>
                                </Stack>
                            </button>

                            <Menu
                                id="basic-menu"
                                anchorEl={columnFilterAnchorEl}
                                open={columnFilterOpen}
                                onClose={handleColumnFilterClose}
                                slotProps={{
                                    paper: {
                                        sx: {
                                            width: 170,
                                            maxHeight: 300,
                                            backgroundColor: themeStyles.topBar.bg
                                        }
                                    }
                                }}
                            >
                                <div className="flex items-center gap-2 px-[16px] py-[6px] w-full">
                                    <input
                                        type="checkbox"
                                        className="form-checkbox cursor-pointer"
                                        checked={selectedColumns?.length === initialColumns?.length ? true : false}
                                        onClick={toggleAll}
                                    />
                                    <span className={`${themeStyles.topBar.tailwindTextColor} font-medium text-[12px]`}>Select All</span>
                                </div>
                                <Divider className="w-full" />
                                {
                                    initialColumns?.map((column, index) => (
                                        <>
                                            <MenuItem
                                                key={index}
                                                sx={{
                                                    fontSize: "12px",
                                                    marginBlock: "0px",
                                                    "&: hover": {
                                                        cursor: "default"
                                                    }
                                                }}
                                            >
                                                <div className="flex items-center gap-2">
                                                    <input
                                                        type="checkbox"
                                                        className="form-checkbox cursor-pointer"
                                                        checked={selectedColumns.includes(column?.headerName)}
                                                        onChange={() => toggleColumn(column?.headerName || "")}
                                                    />
                                                    <span className={`${themeStyles.topBar.tailwindTextColor} font-medium`}>{column?.headerName}</span>
                                                </div>

                                            </MenuItem>
                                            <Divider className="w-full" />
                                        </>

                                    ))
                                }
                            </Menu>
                        </div>
                    </div>
                    <div className="flex items-center gap-1.5">
                        <div >
                            <button
                                className={`flex items-center justify-between py-[5px] px-[12px] gap-2.5 rounded-lg border border-solid ${themeStyles.topBar.tailwindBorderColor}`}
                                aria-controls={open ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick}
                            >
                                <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                >
                                    <span className={`${themeStyles.topBar.tailwindTextColor} text-[14px] font-medium`}>{selectedFilter}</span>
                                    {open ? <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>
                                        keyboard_arrow_up
                                    </span> : <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[25px] font-extralight`}>
                                        keyboard_arrow_down
                                    </span>}
                                </Stack>
                            </button>

                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                slotProps={{
                                    paper: {
                                        sx: {
                                            width: 170,
                                            backgroundColor: themeStyles.topBar.bg
                                        }
                                    }
                                }}
                            >
                                {
                                    activeTabLable === "All" || activeTabLable === "Available" || activeTabLable === "Dirty" ?
                                        filterItems?.map((filter, index) => (
                                            <>
                                                <MenuItem
                                                    key={index}
                                                    sx={{ fontSize: "12px", marginBlock: "0px" }}
                                                    onClick={() => {
                                                        setSelectedFilter(filter.label)
                                                        setVehicleFilterValue(filter.id)
                                                        setAnchorEl(null);

                                                    }}>
                                                    <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>{filter.label}</span>
                                                </MenuItem>
                                                <Divider className="w-full" />
                                            </>

                                        ))
                                        :
                                        filterItems.slice(0, 4)?.map((filter, index) => (
                                            <>
                                                <MenuItem
                                                    key={index}
                                                    sx={{ fontSize: "12px", marginBlock: "0px" }}
                                                    onClick={() => {
                                                        setSelectedFilter(filter.label)
                                                        setVehicleFilterValue(filter.id)
                                                        setAnchorEl(null);

                                                    }}>
                                                    <span className={`${themeStyles.topBar.tailwindTextColor} text-[16px] font-medium`}>{filter.label}</span>
                                                </MenuItem>
                                                <Divider className="w-full" />
                                            </>

                                        ))
                                }
                            </Menu>
                        </div>
                        <div className={`flex px-[5px] py-[6px] items-center gap-2.5 rounded-lg border ${themeStyles.main.borderColor} shadow-sm`}>
                            <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                                search
                            </span>
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchValue}
                                className={`border-none outline-none w-full ${themeStyles.main.textSubHeadingColor} bg-transparent`}
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <CustomDataGrid
                    filteredRows={searchTableData}
                    columns={columns?.map(col => ({
                        ...col,
                        headerClassName: themeStyles.table.headerBg,
                    }))}
                    loading={loading}
                    totalLength={totalLength}
                    paginationModel={paginationModel}
                    setPaginationModel={setPaginationModel}
                />
            </div>
        </div>
    )
}